module.exports = new __parcel__URL__("file-cabinet-open-darkmode.74362355.svg").toString();